import { useState, useEffect } from "react";
import { AsyncPaginate } from "react-select-async-paginate";
import { logOut } from "../config/user";

export default function SuggestionBoxUtil({
  resetKey,
  searchParams,
  selectedValue,
  handleChange,
  api,
  name,
  setInputValue,
  hospitalState,
  selectedProcedures = [],
  styles,
  clearable = false,
  placeholder = "Document Name",
}) {
  const [key, setKey] = useState(0);
  async function loadOptions(search, loadedOptions, { page }) {
    try {
      const trimmedSearch = search.trim();
      let response;
      if (searchParams) {
        response = await api(searchParams, trimmedSearch, page, hospitalState);
      } else if (!searchParams) {
        response = await api(trimmedSearch, page, hospitalState);
      }
      if (!response || !response.data || !Array.isArray(response.data.list)) {
        throw new Error("Invalid API response");
      }
      // Sort the options alphabetically by name
      let options = [];
      if (name === "procedure") {
        options = response.data.list
          .filter(
            (li) =>
              !selectedProcedures.some(
                (sp) => sp.procedureId === li.procedureId,
              ),
          )
          .map((li) => ({
            value: `${li["procedureId"]}-${li[name]}`,
            label: `${li["procedureId"]}-${li[name]}`,
            ...li,
          }))
          .sort((a, b) => a.label.localeCompare(b.label));
      } else {
        options = response.data.list
          .map((li) => ({ value: li[name], label: li[name], ...li }))
          .sort((a, b) => a.label.localeCompare(b.label));
      }
      let hasMore = response.data?.hasMore;
      if (options.length < 1) {
        setInputValue(trimmedSearch);
      } else {
        setInputValue(null);
      }
      return {
        options: options,
        hasMore: hasMore,
        additional: {
          page: page + 1,
        },
      };
    } catch (error) {
      if (error?.response?.status === 401) {
        logOut();
      } else {
        console.error("Error loading options:", error);
      }
      return {
        options: [],
        hasMore: false,
        additional: {
          page: page,
        },
      };
    }
  }
  useEffect(() => {
    if (name === "procedure") {
      setKey((prev) => prev + 1);
    }
  }, [searchParams]);

  return (
    <AsyncPaginate
      key={resetKey}
      loadOptions={loadOptions}
      cacheUniqs={[searchParams]}
      defaultInputValue={selectedValue}
      onChange={handleChange}
      name={name}
      defaultValue={null}
      additional={{ page: 1 }}
      styles={styles}
      isClearable={clearable}
      placeholder={placeholder}
    />
  );
}
